// Image imports
import bms_master from "../assests/bms/BMS Master.jpeg"
import bms_slave from "../assests/bms/BMS Slave.jpeg"
import VS1012 from "../assests/single-phase/VS1012.jpg"
import VS1048 from "../assests/single-phase/VS1048.jpeg"
import VS1424 from "../assests/single-phase/VS1424.jpg"
import VS2036_3048 from "../assests/single-phase/VS2036_3048.jpg"
import VS5048 from "../assests/single-phase/VS5048.jpg"
import VS5096 from "../assests/single-phase/VS5096.JPG"
import VS7512 from "../assests/single-phase/VS7512.jpg"
import VS8012 from "../assests/single-phase/VS8012.jpg"
import VS10180 from "../assests/single-phase/VS10180.jpg"
import CC24V from "../assests/solar/CC24V.jpeg"
import MPPT_48V96V from "../assests/solar/MPPT 48V96V.jpg"
import MPPT_12_24V from "../assests/solar/MPPT_12-24V.jpg"
import VS6072_3Phase from "../assests/three-phase/VS6072_3Phase.jpeg"
import VS10120_3Phase from "../assests/three-phase/VS10120_3Phase.jpg"

export const imageMap = {
  bms_master,
  bms_slave,
  VS1012,
  VS1048,
  VS1424,
  VS2036_3048,
  VS5048,
  VS5096,
  VS7512,
  VS8012,
  VS10180,
  CC24V,
  MPPT_48V96V,
  MPPT_12_24V,
  VS6072_3Phase,
  VS10120_3Phase
};